import { render } from "./SearchResultOpportunity.vue?vue&type=template&id=0063dfd8"
import script from "./SearchResultOpportunity.vue?vue&type=script&lang=js"
export * from "./SearchResultOpportunity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__